export const BUDGET_THRESHOLD_PERCENTAGE = 0.8;
